import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar as MuiAppBar, Box, IconButton, Toolbar } from '@mui/material';
import React from 'react';

import AppLogo from '../AppLogo';

export interface MobileAppBarProps {
  onMenuClick?: () => void;
  sidebarOpen?: boolean;
  hideMenuButton?: boolean;
}

const MobileAppBar: React.FC<MobileAppBarProps> = ({
  onMenuClick,
  sidebarOpen = false,
  hideMenuButton = false,
}) => {
  return (
    <MuiAppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.primary',
        borderBottom: '2px solid rgba(0, 0, 0, 0.06)',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: 48,
          py: 0,
          px: 1,
        }}
      >
        {hideMenuButton ? (
          <Box sx={{ width: 40, mr: 1 }} />
        ) : (
          <IconButton
            color="inherit"
            onClick={onMenuClick}
            aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
            sx={{ mr: 1 }}
          >
            {sidebarOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        )}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AppLogo />
        </Box>
        <Box sx={{ width: 40 }} />
      </Toolbar>
    </MuiAppBar>
  );
};

export default MobileAppBar;
